import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden">
      <div className="py-10 border-b border-white/15">
        <Marquee speed={22} gradient={false}>
          {Array.from({ length: 6 }).map((_, i) => (
            <span
              key={i}
              className="font-mono-x font-extrabold uppercase tracking-tighter text-[16vw] sm:text-[10vw] leading-none mx-6 whitespace-nowrap text-stroke hover:text-white hover:[-webkit-text-stroke:0px] transition-colors duration-300"
              data-testid={i === 0 ? "footer-marquee-brand" : undefined}
            >
              ANTS DON'T SLEEP<span className="text-[#ff3b1d] [-webkit-text-stroke:0px]">.</span>
            </span>
          ))}
        </Marquee>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-white/15">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="px-6 py-10 border-b sm:border-b-0 sm:border-r border-white/15"
          data-testid="footer-booking"
        >
          <p className="font-mono-x text-[10px] tracking-[0.3em] text-white/40 uppercase mb-4">
            BOOKING
          </p>
          <a
            href="tel:+17723324038"
            data-testid="footer-phone-link"
            className="font-mono-x text-xl font-bold tracking-tight hover:text-[#ff3b1d] transition-colors duration-200"
          >
            772-332-4038
          </a>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="px-6 py-10 border-b sm:border-b-0 sm:border-r border-white/15"
          data-testid="footer-domain"
        >
          <p className="font-mono-x text-[10px] tracking-[0.3em] text-white/40 uppercase mb-4">
            TRANSMISSION HQ
          </p>
          <img
            src="/ads-logo.png"
            alt="ANTS DON'T SLEEP logo"
            className="w-20 h-20 mb-4 border border-white/15"
            data-testid="footer-logo"
          />
          <p className="font-mono-x text-sm tracking-wider text-white/70">ANTSDONTSLEEP</p>
          <p className="font-mono-x text-[11px] tracking-wider text-white/40 mt-2">
            FLORIDA / WHEREVER THE WAREHOUSE IS
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="px-6 py-10"
          data-testid="footer-status"
        >
          <p className="font-mono-x text-[10px] tracking-[0.3em] text-white/40 uppercase mb-4">
            STATUS
          </p>
          <p className="font-mono-x text-sm tracking-wider">
            <span className="inline-block w-2 h-2 bg-[#ff3b1d] mr-3 blink" />
            ACCEPTING BOOKINGS
          </p>
        </motion.div>
      </div>

      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 px-6 py-5 font-mono-x text-[10px] tracking-[0.25em] text-white/35 uppercase">
        <span data-testid="footer-copyright">© 2026 ANTS DON'T SLEEP — ALL NOISE RESERVED</span>
        <span data-testid="footer-credit">BUILT IN THE DARK</span>
      </div>
    </footer>
  );
}
